// extracted by mini-css-extract-plugin
export default {"link":"listLink_link__pRI13"};